import React, { useContext } from 'react';
import UserContext from '../../context/userContext.js';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../authentication/login';
import ImmunoForm from '../immunoForm/immunoForm';

export default function Routing({ loginProcess }) {
  const userDetail = useContext(UserContext);
  if (userDetail.token) {
    return (
      <Routes>
        <Route path="/form" element={<ImmunoForm />} />
        <Route path="*" element={<Navigate to="/form" replace />} />
      </Routes>
    );
  } else if (userDetail.token === null) {
    return <Login loginProcess={loginProcess} />;
  } else {
    return <></>;
  }
}
